<template>
  <section id="faq">
    <div class="wrap">
      <div class="section-head">
        <div class="left">
          <span class="eyebrow"><span class="dot"></span>{{ labelsState['lv_faq_eyebrow'] || 'Frequently asked questions' }}</span>
          <h2>{{ labelsState['lv_faq_heading_pre'] || 'What' }} <span class="grad-text">{{ labelsState['lv_faq_heading_grad'] || 'everyone asks.' }}</span></h2>
        </div>
        <div class="right">
          {{ labelsState['lv_faq_contact_pre'] || 'Missing something? Write to us at' }}
          <a href="mailto:hola@nqartificial.com" style="color:var(--cyan); text-decoration:none">hola@nqartificial.com</a>.
        </div>
      </div>
      <div class="faq">
        <div
          v-for="(f, i) in items"
          :key="i"
          :class="['faq-item', { open: openIndex === i }]"
        >
          <div class="faq-summary" @click="toggle(i)">
            <span>{{ labelsState[f.qKey] || f.q }}</span>
            <span class="faq-toggle">{{ openIndex === i ? '−' : '+' }}</span>
          </div>
          <div v-if="openIndex === i" class="faq-body">{{ labelsState[f.aKey] || f.a }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';

export default {
  name: 'FAQV2',
  setup() {
    const labelsStore = useLabelsStore();
    const languageStore = useLanguageStore();
    onMounted(() => labelsStore.fetchAndSetLabels(languageStore.language));
    return { labelsState: computed(() => labelsStore.labels) };
  },
  data() {
    return {
      openIndex: 0,
      items: [
        {
          qKey: 'lv_faq_setup_time_question', q: 'How long does it take to set up the assistant?',
          aKey: 'lv_faq_setup_time_answer',   a: 'Between 3 and 15 minutes for a basic setup. Upload your sources, define the tone and publish. For advanced integrations (CRM, ERP), one day.',
        },
        {
          qKey: 'lv_faq_replaces_team_question', q: 'Does it replace my support team?',
          aKey: 'lv_faq_replaces_team_answer',   a: 'No. NQA absorbs 80% of repetitive queries and escalates complex cases to your team with full client context.',
        },
        {
          qKey: 'lv_faq_languages_question', q: 'What languages does it support?',
          aKey: 'lv_faq_languages_answer',   a: 'Spanish (LATAM, neutral and regional), English, Portuguese and Italian out of the box. Others on demand with the Scale plan.',
        },
        {
          qKey: 'lv_faq_data_security_question', q: 'Is my data secure?',
          aKey: 'lv_faq_data_security_answer',   a: 'Yes. AES-256 encryption, hosting in selectable regions (US, EU, BR), GDPR compliance and Habeas Data regulation.',
        },
        {
          qKey: 'lv_faq_free_trial_question', q: 'Can I try it without paying?',
          aKey: 'lv_faq_free_trial_answer',   a: 'Yes: 14 days free on the Pro plan, no card required. If you are not convinced, there is nothing to cancel.',
        },
        {
          qKey: 'lv_faq_message_billing_question', q: 'How are messages billed?',
          aKey: 'lv_faq_message_billing_answer',   a: 'Per AI-generated message (inbound and response). Human handover messages do not count against your quota.',
        },
      ],
    };
  },
  methods: {
    toggle(i) {
      this.openIndex = this.openIndex === i ? null : i;
    },
  },
};
</script>
